'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGIONS = {
  northAmerica: 'NA',
  latinAmerica: 'LA',
  emea: 'EMEA',
  asia: 'APA'
};

exports.default = REGIONS;


//////////////////
// WEBPACK FOOTER
// ./lib/config/regions.js
// module id = 596
// module chunks = 0